module.exports = __webpack_public_path__ + "static/media/ios-radio-button-off.0a5f679a.svg";